import { Field } from 'formik';
import { elementType, func, node, oneOfType, string } from 'prop-types';
import { Text, Stack } from '@chaser/components';
import React from 'react';

const FieldWithErrorLabel = ({
  name,
  children = undefined,
  as: Comp = undefined,
  type = undefined,
  validate = undefined,
  ...rest
}) => (
  <Field name={name} type={type} validate={validate}>
    {({ field, form }) => {
      const error = form.touched[name] && form.errors[name];
      return (
        <Stack gap="xsmall" width="100%">
          {Comp ? (
            <Comp {...field} error={!!error} {...rest} type={type}>
              {children}
            </Comp>
          ) : (
            children({ field, error, form })
          )}
          <Text color="Red" size="xsmall">
            {error}
          </Text>
        </Stack>
      );
    }}
  </Field>
);

FieldWithErrorLabel.propTypes = {
  name: string.isRequired,
  children: oneOfType([node, func]),
  type: string,
  as: elementType,
  validate: func,
};

export default FieldWithErrorLabel;
